import { PAM_SECTIONS } from "../pamSections";

// PAM mode inside the MFA switcher. PAM is not an MFA method — it shares the
// switcher as the fourth product surface alongside AD / Database / RADIUS.
//
// Defined in ../pamSections so this and pamAccess.js cannot drift apart.
const mfaPamNavigation = PAM_SECTIONS;

export default mfaPamNavigation;
